import { computed, ComputedRef } from "vue";
import { useLayoutStore } from "@/stores/layout";

export default function useSidebar() {
  const layout = useLayoutStore();
  const isPrimaryMinimized: ComputedRef<boolean> = computed(() => layout.isPrimaryMinimized);
  const isSecondaryOpen: ComputedRef<boolean> = computed(() => layout.isSecondaryOpen);
  const isAutoFold: ComputedRef<boolean> = computed(() => layout.isAutoFold);

  const enableAutoFold = (): void => {
    layout.setAutoFold(true);
  };

  const disableAutoFold = (): void => {
    layout.setAutoFold(false);
  };

  const togglePrimarySidebar = (): void => {
    layout.togglePrimarySidebar();
    updateBodyClasses();
  };

  const toggleSecondarySidebar = (): void => {
    layout.toggleSecondarySidebar();
    updateBodyClasses();
  };

  const setPrimaryMinimized = (value: boolean): void => {
    layout.setPrimaryMinimized(value);
    updateBodyClasses();
  };

  const setSecondaryOpen = (value: boolean): void => {
    layout.setSecondaryOpen(value);
    updateBodyClasses();
  };

  const updateBodyClasses = (): void => {
    document.body.classList.toggle("is-primary-min", isPrimaryMinimized.value);
    document.body.classList.toggle("is-secondary-open", isSecondaryOpen.value);
  };

  return {
    isAutoFold,
    isPrimaryMinimized,
    isSecondaryOpen,
    enableAutoFold,
    disableAutoFold,
    togglePrimarySidebar,
    toggleSecondarySidebar,
    setPrimaryMinimized,
    setSecondaryOpen,
  };
}
